import envCredentials from "./env";

export async function getApiConfig() {
  try {
    //const BASE_URL = "https://localhost:7257/api/";

    /* PROD */
     const BASE_URL = "https://api.myreportin.com:4403/api/";

    /* DEMO */
     //const BASE_URL = "https://api1.myreportin.com:444/api/";

    /* DEV */
    //const BASE_URL = "https://api1dev.myreportin.com:4404/api/";

    const HEADERS_CONFIG = {
      headers: {
        Accept: "text/plain",
        "x-api-key": `${(envCredentials()).API_KEY}`,
      },
      withCredentials: true,
    };

    return { BASE_URL, HEADERS_CONFIG };

  } catch (error) {
    console.error("Error fetching the API:", error);
  }
}


